import React from 'react';
import LessonCard from '@/components/shared/NewDashboard/Cards/LessonCard';
import Grid from '@/components/shared/NewLessonOverview/Cards/Grid';
import useLessons from '@/hooks/api/useLessons';
import Spinner from '@/components/common/Spinner';

type LessonSectionProps = {
  overviewColor: string,
  programId: number,
  unitColor: string,
  unitId: number,
};

const LessonSection = ({ overviewColor, programId, unitColor, unitId }: LessonSectionProps) => {
  const { lessons, isLoading } = useLessons({
    attributes: [
      'id', 'title', 'image_url', 'engineering_icon', 'position', 'performance_expectations', 'title_number',
    ],
    programId,
    unitId,
  });

  if (isLoading) return <Spinner />;

  return (
    <>
      <div className="tw-flex tw-justify-center tw-px-2 card-2col:tw-px-[2rem] tw-pt-[1rem] tw-pb-8">
        <Grid className="tw-justify-center chromebook-plus:!tw-px-4 chromebook-plus:!tw-ml-0">
          {lessons && lessons.map(lesson => (
            <LessonCard
              key={lesson.id}
              lesson={lesson}
              overviewColor={overviewColor}
              programId={programId}
              unitColor={unitColor}
            />
          ))}
        </Grid>
      </div>
    </>
  );
};

export default LessonSection;
